import { MP_ANIMATION_LIBRARY } from '@/config/avatarAnimations';

// Exact archive addresses, not a substring or a caller-provided directory name.
const REGISTERED_MP_CLIPS = new Set<string>(Object.values(MP_ANIMATION_LIBRARY));
const GLB_CLIP_SEGMENT = /\.glb(\?|$)/i;

/** Unsupported extensions are rejected before any external fetch. */
export function isGlbClipUrl(url: string | null | undefined): boolean {
  return !!url && GLB_CLIP_SEGMENT.test(url);
}

/**
 * Legacy API name: verifies registration/origin, NOT skeleton compatibility.
 * ActorCore provenance and an MP pathname cannot prove a target rig matches.
 * nativeMotion blocks every external clip independently of this registry.
 */
export function isMpRiggedClipUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    if (parsed.username || parsed.password) return false;
    // Query/hash may cache-bust a registered object but cannot supply its identity.
    return REGISTERED_MP_CLIPS.has(parsed.origin + parsed.pathname);
  } catch { return false; }
}

/** Never partially preload a state set containing an incompatible clip. */
export function areAllMpRiggedClips(
  urls: Record<string, string> | null | undefined,
): boolean {
  if (!urls) return false;
  const values = Object.values(urls);
  return values.length > 0 && values.every(isMpRiggedClipUrl);
}

/** An active external MP clip owns its Spine pose, so legacy tilt must not overwrite it. */
export function isMpRiggedClipDriving(args: {
  currentClipUrl: string | null | undefined;
  stateClipsAllMpRigged: boolean;
  stateClipsLoaded: boolean;
}): boolean {
  if (isMpRiggedClipUrl(args.currentClipUrl)) return true;
  return args.stateClipsAllMpRigged && args.stateClipsLoaded;
}
